import reducer, {ActionType, LOCAL_STORAGE_KEY} from "./reducer";
import {useReducer} from "react";
import initialState from "./state"

const UseAppData = () => {

    const [state, dispatch] = useReducer(
        reducer,
        localStorage.getItem(LOCAL_STORAGE_KEY) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) : initialState)

    const setApiEndpoint = value => dispatch({type: ActionType.SetApiEndpoint, value})

    const setUser = value => dispatch({type: ActionType.SetUser, value})

    const setEnv = value => dispatch({type: ActionType.SetEnv, value})

    const setColumnDefs = value => dispatch({type: ActionType.SetColumnDefs, value})

    const setViewMode = value => dispatch({type: ActionType.SetViewMode, value})

    const setDirection = value => dispatch({type: ActionType.SetDirection, value})

    const setCondition = value => dispatch({type: ActionType.SetCondition, value})

    const refreshTreeLayer = () => dispatch({type: ActionType.RefreshTreeLayer})

    const setTreeInfoModel = value => dispatch({type: ActionType.SetTreeInfoModel, value})

    const setFilterModel = value => dispatch({type: ActionType.SetFilterModel, value})

    const setSelectedTreeModel = value => dispatch({type: ActionType.SetSelectedTreeModel, value})

    const setTabMode = value => dispatch({type: ActionType.SetTabMode, value})

    return {
        state,
        setApiEndpoint,
        setUser,
        setEnv,
        setColumnDefs,
        setViewMode,
        setDirection,
        setCondition,
        refreshTreeLayer,
        setTreeInfoModel,
        setSelectedTreeModel,
        setFilterModel,
        setTabMode,
    }
}

export default UseAppData
